import { useEffect, useState } from 'react';

/* Renders its children only for dropshippers (user type 3).
   To also include guest buyers, pass allowedTypes={[3, 5]}.

   NOTE: this is a display gate, not a security control. The calculator only does
   arithmetic on a price that is already public. */

export const DROPSHIPPER_TYPES = [3];

// Reads the logged-in user's type from localStorage['user'] (the key the apps use).
// If the main app keeps the user in Redux/Context instead, pass `userType` explicitly.
function readStoredUserType() {
  try {
    const raw = window.localStorage.getItem('user');
    if (!raw) return null;
    const u = JSON.parse(raw);
    const t = u && (u.type !== undefined ? u.type : u.user && u.user.type !== undefined ? u.user.type : u.user_type);
    return t === undefined || t === null ? null : Number(t);
  } catch (e) {
    return null;
  }
}

export function useStoredUserType() {
  const [type, setType] = useState(null);
  useEffect(() => {
    const sync = () => setType(readStoredUserType());
    sync();
    window.addEventListener('storage', sync);
    window.addEventListener('focus', sync);
    return () => {
      window.removeEventListener('storage', sync);
      window.removeEventListener('focus', sync);
    };
  }, []);
  return type;
}

export default function DropshipperOnly({ children, allowedTypes = DROPSHIPPER_TYPES, userType }) {
  const stored = useStoredUserType();
  const type = userType !== undefined ? userType : stored;
  if (type === null || type === undefined || !allowedTypes.includes(Number(type))) return null;
  return children;
}
